import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import setting from './modules/setting'
import pageDesign from './modules/pageDesign'

const modulesFiles = require.context('./modules', false, /\.js$/)

const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  console.log()
  modules[moduleName] = value.default
  return modules
}, {})
Vue.use(Vuex)
const modulLes = { pageDesign }
const store = new Vuex.Store({
  modules:{user,modules,setting,pageDesign}, 
  getters,
  modulLes
})

// document.addEventListener('click', evnt => store.commit('setEvent', evnt))
// window.addEventListener('resize', evnt => store.commit('setEvent', evnt))

export default store



// WEBPACK FOOTER //
// ./src/SRM/store/index.js